<template>
    <div>
        <button
            class="btn btn-md is-ghost"
            type="button"
            @click="$modal.show('move-address-to-project')"
        >
            Flytta adress
        </button>
        <adaptive-form-modal
            name="move-address-to-project"
            primary-button-text="Flytta adressen"
            primary-button-class="is-primary"
            title="Flytta denna adress till ett annat projekt"
            method="post"
            :action="actionRoute"
            :callback="reloadPage"
        >
            <p>
                {{ modalInformation }}
            </p>

            <select
                v-model="targetProjectId"
                required
                class="form-input"
                name="target_project_id"
            >
                <option
                    v-for="(id, name) in projects"
                    :value="id"
                >
                    {{ name }}
                </option>
            </select>
            <input
                type="hidden"
                name="addresses[]"
                :value="address.id"
            >
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
            project: {
                type: Object,
                required: true,
            },
            projects: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                targetProjectId: null,
                actionRouteName: null,
                callbackRouteName: null,
                modalInformation: 'Detta kommer att flytta adressen till det valda projektet.',
            };
        },
        computed: {
            actionRoute() {
                if (! this.actionRouteName) {
                    console.error('You need to add the actionRouteName');

                    return;
                }

                return route(this.actionRouteName, this.project);
            },
        },
        mounted() {
            if (Object.keys(this.projects).length) {
                this.targetProjectId = Object.values(this.projects)[0];
            }
        },
        methods: {
            reloadPage() {
                if (! this.callbackRouteName) {
                    console.error('You need to add the callbackRouteName');

                    return;
                }

                window.location = route(this.callbackRouteName, [this.targetProjectId, this.address]);
            },
        },
    };
</script>
